export default "__VITE_ASSET__bd3f72c0__"